import { isAndroid, isIOS, isMiniWx, isUniApp } from '../../utils/browser';
import { jumpToTMSPage } from '../../utils/jsBridge';
import { getPathParams } from "../../utils/utils";

/**
 * T3.6.0司机注册签署改造，区分小程序、IOS、Android跳转交互
 * @param {*} signStatus 授权协议签订状态
 * @param {*} sourceEnv 对接来源，【小程序：miniProgram | 原生app: app | pc: pc | 移动端浏览器：mobileBrowser】
 * @param {*} backUrl 回跳地址（小程序、PC、浏览器等需要）
 */
export function notify(signStatus = false, sourceEnv = null, backUrl = '') {
    try{
      setTimeout(() => {
        let new_backUrl = backUrl ? decodeURIComponent(backUrl) : '';
        console.log(isMiniWx(), isIOS(), isAndroid(), sourceEnv,'notify-----------------', new_backUrl)
         if (isUniApp()) {//uniapp小程序内，通讯传递注册协议签订状态
          if (new_backUrl) {
            let backUrlParam = getPathParams(new_backUrl.slice(new_backUrl.indexOf('?')));
            if (backUrlParam.isTabPage) {//小程序tab页面
              //通讯传递注册协议签订状态
              window.uni.postMessage({
                data: {
                  signStatus,
                  type: 'signStatus',
                },
              });
              let miniUrl = new_backUrl.slice(0,new_backUrl.indexOf('?'));
              window.uni.switchTab({"url": miniUrl});
            } else {//小程序普通页面
              window.uni.postMessage({
                data: {
                  signStatus,
                  type: 'signStatus',
                },
              });
              window.uni.navigateTo({"url": new_backUrl})
            }
          }
        } else if(isMiniWx()){//小程序内，通讯传递注册协议签订状态
          if (new_backUrl) {
            let backUrlParam = getPathParams(new_backUrl.slice(new_backUrl.indexOf('?')));
            if (backUrlParam.isTabPage) {//小程序tab页面
              //通讯传递注册协议签订状态
              window.wx.miniProgram.postMessage({
                data: {
                  signStatus,
                  type: 'signStatus',
                },
              });
              let miniUrl = new_backUrl.slice(0,new_backUrl.indexOf('?'));
              window.wx.miniProgram.switchTab({"url": miniUrl});
            } else {//小程序普通页面
              window.wx.miniProgram.postMessage({
                data: {
                  signStatus,
                  type: 'signStatus',
                },
              });
              window.wx.miniProgram.navigateTo({"url": new_backUrl})
            }
          }
          
        } else if ((isIOS() || isAndroid()) && sourceEnv !== 'mobileBrowser') {//移动端app内 且 非移动端浏览器内，触发原生定义方法；
          jumpToTMSPage(signStatus);
        } else {//H5直接跳转backUrl
          console.log('pc---浏览器访问回跳-----------', `${new_backUrl}?signStatus=${signStatus}`)
          new_backUrl && window.open(`${new_backUrl}?signStatus=${signStatus}`, '_self');
        }
      }, 1000)
    }catch(e){
      console.log('-----------',e);
    }
  
  };


// WEBPACK FOOTER //
// ./src/routes/author/utils.js